import { sortBy } from 'lodash'
import { nodes, schema, StrongNode } from 'prose-core'
import { Node as ProseNode } from 'prosemirror-model'

/**
 * Finds the closest code block to the given position in the document.
 * @param doc tr.doc
 * @param pos the position around which to search for a code block
 * @returns a tuple in the form `[pos, node]`, or `null` if there are no code blocks in the document
 */
export const findClosestCodeBlock = (doc: ProseNode, pos: number) => {
  const foundCodeBlocks: Array<[pos: number, node: StrongNode<typeof nodes.code_block>]> = []
  doc.nodesBetween(0, doc.content.size, (node, pos) => {
    // don't descend into paragraphs
    if (node.type === schema.nodes.paragraph) return false
    if (node.type.name === 'code_block') {
      foundCodeBlocks.push([pos, node as StrongNode<typeof nodes.code_block>])
      // don't descend into code blocks
      return false
    }
    // descend into everything else
    return true
  })
  if (foundCodeBlocks.length === 0) return null
  const closestCodeBlock = sortBy(foundCodeBlocks, ([codeBlockPos]) => Math.abs(codeBlockPos - pos))[0]
  return closestCodeBlock
}
